import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DiscreteColorLegend, RadialChart } from 'react-vis';
import { useResizeDetector } from 'react-resize-detector';

import {
  color,
  defaultLabel,
  renderHint,
  sortFunctionByValue,
  renderDiscrete,
} from '../../../utils';

// Composant graphique pour afficher un Donut chart.
const Donut = props => {
  const [hint, setHint] = useState(false);
  const [data, setData] = useState([]);
  const { width, ref } = useResizeDetector();

  useEffect(() => {
    if (!props.data) return;

    let processedData = props.data || [];
    processedData = processedData.sort((a, b) => sortFunctionByValue(a, b));

    processedData = processedData.map((d, i) => {
      if (typeof d.label === 'number') {
        if (d.label === 0) d.label = 'Non';
        if (d.label === 1) d.label = 'Oui';
      }

      d.label = d.label ? String(d.label) : defaultLabel;
      d.color = color(i, d.label, props.colorPalette);

      return d;
    });

    setData(processedData);
  }, [props.data, props.refreshes, props.colorPalette]);

  const processedData = [...data];

  // Logique pour les effets du hover.
  (processedData || []).forEach(d => {
    if (hint) {
      d.className = d.label === hint.label ? 'hovered' : 'not-hovered';
    } else {
      d.className = '';
    }
  });

  const diameter = (width > props.height ? props.height : width) - 30;

  return (
    <div
      style={{ width: '50%', height: '100%' }}
      className="pie-chart-wrap"
      ref={ref}
    >
      <RadialChart
        colorType="literal"
        animation="noWobble"
        width={width || props.height}
        height={props.height}
        innerRadius={diameter / 2 - 25}
        radius={diameter / 2 - 0}
        getAngle={d => d.value}
        data={processedData || []}
        padAngle={0.06}
        onValueMouseOver={v => setHint(v)}
        onSeriesMouseOut={() => setHint(false)}
      >
        {hint && renderHint(hint, props.hint && props.hint(hint))}

        <DiscreteColorLegend
          items={(processedData || []).map((d, i) => ({
            title: renderDiscrete(d),
            color: color(i, d.label, props.colorPalette),
            disabled: d.className === 'not-hovered',
            hint: { ...d, x: 1, y: -1 },
          }))}
          onItemMouseEnter={item => setHint(item.hint)}
          onItemMouseLeave={() => setHint(false)}
        />
      </RadialChart>
    </div>
  );
};

Donut.propTypes = {
  refreshes: PropTypes.number,
  height: PropTypes.number,
  colorPalette: PropTypes.string,
  hint: PropTypes.bool,
  data: PropTypes.array,
};

export default Donut;
